import * as WxPagination from './components/WxPagination.css';

export default { WxPagination };
